import React from 'react';
import { ZapIcon, ShieldCheckIcon, LayersIcon, SparklesIcon } from 'lucide-react';
export function WhyChooseUsSection() {
  const features = [{
    num: '01',
    icon: <ZapIcon className="w-7 h-7 text-[#D4AF37]" data-id="element-222" />,
    title: 'Performance Driven',
    description: 'Every store and product we build is optimized for speed and conversion.'
  }, {
    num: '02',
    icon: <ShieldCheckIcon className="w-7 h-7 text-[#D4AF37]" data-id="element-223" />,
    title: 'Built for Shopify',
    description: "Our themes and apps follow Shopify's strict development standards."
  }, {
    num: '03',
    icon: <LayersIcon className="w-7 h-7 text-[#D4AF37]" data-id="element-224" />,
    title: 'Scalable Architecture',
    description: "Whether you're a startup or a global brand, our solutions scale with your business."
  }, {
    num: '04',
    icon: <SparklesIcon className="w-7 h-7 text-[#D4AF37]" data-id="element-225" />,
    title: 'Premium Design',
    description: "Inspired by the world's best digital experiences."
  }];
  return <section className="section-padding bg-black relative border-t border-white/5" data-id="element-226">
      <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-227">
        <h2 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-228">
          Why Choose Design Flow Digitals
        </h2>
        <p className="text-xl text-gray-400" data-id="element-229">
          We combine technical excellence with premium design to deliver
          unmatched results.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-230">
        {features.map((feature, index) => <div key={index} className="group relative glass-card p-8 text-center flex flex-col items-center overflow-hidden transition-all duration-300 hover:-translate-y-1 hover:border-[#D4AF37]/30" data-id="element-231">
            {/* Background Number */}
            <div className="absolute -right-4 -bottom-8 text-9xl font-bold text-white/[0.02] select-none pointer-events-none group-hover:text-[#D4AF37]/5 transition-colors duration-500" data-id="element-232">
              {feature.num}
            </div>

            {/* Subtle gradient border on hover */}
            <div className="absolute inset-0 bg-gradient-to-b from-[#D4AF37]/0 to-[#D4AF37]/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" data-id="element-233" />

            <div className="w-16 h-16 rounded-full bg-[#D4AF37]/10 flex items-center justify-center mb-6 group-hover:scale-110 group-hover:bg-[#D4AF37]/20 transition-all duration-300 relative z-10" data-id="element-234">
              {feature.icon}
            </div>

            <div className="relative mb-4 z-10" data-id="element-235">
              <h3 className="text-xl font-bold text-white group-hover:text-[#D4AF37] transition-colors" data-id="element-236">
                {feature.title}
              </h3>
              <div className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-0 h-[2px] bg-gradient-gold group-hover:w-1/2 transition-all duration-300" data-id="element-237" />
            </div>

            <p className="text-gray-400 text-sm leading-relaxed relative z-10" data-id="element-238">
              {feature.description}
            </p>
          </div>)}
      </div>
    </section>;
}